/*eslint-disable react/no-did-mount-set-state */
import React from 'react';
import {findDOMNode} from 'react-dom';
import ClipboardButton from 'react-clipboard.js';
import results from '../../data/results.json';

import facebookIcon from '../../images/facebookIcon.svg';
import twitterIcon from '../../images/twitterIcon.svg';
import linkedinIcon from '../../images/linkedinIcon.svg';
import redditIcon from '../../images/redditIcon.svg';
import emailIcon from '../../images/emailIcon.svg';
import clippy from '../../images/clippy.svg';

const progress_bar_height = 250;
const compare = (a,b) => {
  if (a.them.status > b.them.status)
    return -1;
  else if (a.them.status < b.them.status)
    return 1;
  else
    return 0;
};

class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {marginTop: 0};
  }

  componentDidMount() {
    const {stats} = this.props;
    if (!stats.on_netlify.value) {
      const diff = (progress_bar_height - findDOMNode(this).offsetHeight) / 2;
      this.setState({marginTop: diff});
    }
    return 0;
  }

  aRecordWarning() {
    return [<li className="results__overview__item is-message">
      <div>Your site is on Netlify, but you’re not taking full advantage of our
      global content delivery network.</div>
      <div>You should always link your domain to Netlify with a CNAME record
      when possible, and avoid using an A record with a single IP.</div>
      <div>A CNAME will let Netlify direct the user to the closest CDN point
      of presence, which improves performance by an order of magnitude.</div>
      <div>Most DNS providers won’t allow CNAME records for a “naked domain”,
      since this is not well supported by the DNS spec.</div>
      <div>If you stay with a DNS provider that requires an A record on the
      naked domain, we recommend that you use the www domain as your primary
      address.</div>
    </li>];

    /* Insert when it's up:
    <div>However, if you use Netlify’s integrated DNS hosting, you can link
    your naked domain directly to Netlify’s global traffic director and
    get full DNS performance even on a naked domain name.</div>
    */
  }

  perfect() {
    return [<li className="results__overview__item is-good">
      Your website scored near perfect results. Good job!
    </li>];
  }

  sentences() {
    const {stats, isBroken} = this.props;
    if (stats.on_netlify.value && stats.same_ip.value) {
      return this.aRecordWarning();
    }

    const sentences = [];
    if (isBroken) {
      sentences.push({
        label: "We were unable to connect to this site",
        badLabel: "We were unable to connect to this site",
        status: "critical"
      });
    } else {
      for (const key in stats) {
        const result = results[key];

        if (result && result.visible) {
          const criteria = result && result.criteria;
          let status = null;

          if (criteria && criteria[1] < stats[key].value || (criteria && criteria[1] < stats[key].value)) {
            status = "critical";
          } else if (criteria && criteria[0] < stats[key].value) {
            status = "warning";
          } else if (criteria == null && stats[key].value == false) {
            status = "critical";
          }

          if (status)  {
            sentences.push({
              label: result.label,
              badLabel: result.badLabel,
              data: stats[key],
              status: status
            });
          }
        }
      }
    }

    return sentences.map((sentence, index) => (
      <li key={index} className={`results__overview__item is-${sentence.status}`}>{sentence.badLabel}</li>
    ));
  }

  render() {
    const {marginTop} = this.state;
    const warnings = this.sentences();
    const share_url = location.href;
    const facebook_share_url ="http://www.facebook.com/share.php?u=" + share_url;
    const twitter_share_url ="https://twitter.com/share?url=" + share_url + "&amp;text=Check%20out%20my%20site%20score%20";
    const linkedin_share_url ="http://www.linkedin.com/shareArticle?mini=true&amp;url=" + share_url;
    const hackernews_share_url ="https://news.ycombinator.com/submitlink?u=" + share_url;
    const reddit_share_url ="http://reddit.com/submit?url=" + share_url;
    const email_share_url ="mailto:?body=" + share_url;

    return (
      <div className="results__overview">
        <div className="results__overview__title">Overview</div>
        <ul>
          {warnings.length ? warnings : this.perfect()}
        </ul>

        <div className="results__intro">*Testmysite.io rates your site based on its initial global load times and its security settings.</div>

        <div className="share-button">
          <div className="share-button-content">
            <input type="checkbox" className="checkbox" id="share" />
            <label htmlFor="share" className="label entypo-export">Share your results</label>
            <div className="social">
              <div className="copy-link-group">
                <input type="text" value={share_url} />
                <span className="copy-link-group-button">
                  <ClipboardButton data-clipboard-text={share_url}><img src={clippy}/></ClipboardButton>
                </span>
              </div>
              <ul>
                <a href={facebook_share_url} target="_blank"><li className="entypo-facebook"><img src={facebookIcon} /></li></a>
                <a href={twitter_share_url} target="_blank"><li className="entypo-twitter"><img src={twitterIcon} /></li></a>
                <a href={linkedin_share_url} target="_blank"><li className="entypo-linkedin"><img src={linkedinIcon} /></li></a>
                <a href={hackernews_share_url} target="_blank"><li className="entypo-hackernews">HN</li></a>
                <a href={reddit_share_url} target="_blank"><li className="entypo-reddit"><img src={redditIcon} /></li></a>
                <a href={email_share_url} target="_blank"><li className="entypo-mail"><img src={emailIcon} /></li></a>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Overview.propTypes = {
  stats: React.PropTypes.object,
  onNetlify: React.PropTypes.bool,
  sameIp: React.PropTypes.bool
};

export default Overview;



// WEBPACK FOOTER //
// ./src/components/results/Overview.js